export const USERS_ACTIONS: Record<string, string> = {
  createUser: "Create User",
  activateUser: "ActivateUser",
  deactivateUser: "DeactivateUser",
  resetPassword: "Reset Password",
  login: "Log in",
  googleLogin: "Google Login",
  logout: "Log out",
};

export const LOGIN_ACTIONS: Record<string, string> = {
  createLogin: "Create Login",
  editLogin: "Edit Login",
  startLogin: "Start Login",
  stopLogin: "Stop Login",
  enableLogin: "Enable Login",
  disableLogin: "Disable Login",
};
